/**
 * Whether an Escape keydown belongs to an open dropdown, menu, autocomplete or datepicker rather than to the modal
 * under it. Those panels live in the CDK overlay container, outside the modal, and handle Escape themselves (most of
 * them by calling preventDefault); a window-level Escape listener still receives the event afterwards and, without
 * this check, closed the whole modal together with the panel.
 */
export function escapeBelongsToOverlay(event?: Event, options: { ignoreCalendars?: boolean } = {}): boolean {
  const panes = Array.from(document.querySelectorAll('.cdk-overlay-container .cdk-overlay-pane:not(:empty)'));
  // A modal whose calendar reopens itself (range-dates with keepCalendarOpen) always has a calendar pane attached, and
  // that calendar also handles Escape (preventDefault), so neither can count or Escape would never close that modal.
  const relevant = options.ignoreCalendars ? panes.filter((pane) => !pane.querySelector('mat-datepicker-content')) : panes;
  if (event?.defaultPrevented) {
    return !options.ignoreCalendars || relevant.length > 0;
  }
  // The datepicker closes on Escape without preventDefault; its pane is still attached when the event reaches window.
  return relevant.length > 0;
}
